import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactSelect from "react-select";
import DateFilter from "../../../components/common/DateFilter";
import { getAllUsers } from "../../../config/LiveApi";
import "./ReleaseReport.css";

function ReleaseHeader({
  onDateChange,
  selectedMerchant,
  setSelectedMerchant,
}) {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const [merchantNames, setMerchantNames] = useState([]);

  const canSelectMerchant =
    role === "super" || role === "operation" || role === "subSuper";

  useEffect(() => {
    if (!canSelectMerchant) return;
    const fetchMerchNames = async () => {
      try {
        const response = await getAllUsers(token, 1);
        const filteredData = (response?.data || []).filter(
          (merchant) => merchant.role === "admin",
        );
        setMerchantNames(filteredData);
      } catch (error) {
        console.error("Error fetching merchants:", error.message);
      }
    };

    fetchMerchNames();
  }, [token]);

  const merchantOptions = merchantNames.map((item) => ({
    value: item.id,
    label: item.alias,
  }));

  return (
    <>
      <div className="rr-release-header">
        <div>
          <h2 className="area-top-management">
            Rolling Reserve Release Report
          </h2>
          <p className="rr-release-subtitle">
            Live view of released rolling reserve.
          </p>
        </div>

        {canSelectMerchant && (
          <div className="rr-release-filters">
            <ReactSelect
              value={selectedMerchant}
              options={merchantOptions}
              onChange={setSelectedMerchant}
              placeholder="Select Merchant"
              isClearable
            />
          </div>
        )}
      </div>

      <DateFilter onDateChange={onDateChange} />
    </>
  );
}

export default ReleaseHeader;
